import { css, errorStyle } from "./SKT";
import { SKTBaseComponent } from "./SKTBaseComponent";
import { SKTToggle } from "./SKTToggle";

const SKTDimensionPart = ({ id, data, unit, prefix }) => {
  const onchange = (event) => {
    data.set(id, event.target.value);
  };
  const isValid = data && data.isValid(id);
  const feedback = data && data.feedback(id);
  return (
    <div className={css("col-md-12 col-lg-2")}>
      <div className={css("skt-invalid-feedback")}>
        <SKTToggle when={!isValid}>{feedback}</SKTToggle>
        &nbsp;
      </div>
      <div className={css("input-group")}>
        <span className={css("input-group-addon info-popup")}>{prefix}</span>
        <input
          aria-describedby="basic-addon2"
          className={css("form-control")}
          style={errorStyle(data.isValid(id))}
          id={id}
          name={id}
          placeholder="100"
          type="text"
          onChange={onchange}
          value={data.get(id)}
        />{" "}
        <span className={css("input-group-addon")}>{unit}</span>
      </div>
    </div>
  );
};

const Times = () => {
  return (
    <div className={css("col-md-12 col-lg-1 form-control times-block")}>
      <div className={css("times")}>&times;</div>
    </div>
  );
};

export const SKTDimensions = ({ data }) => {
  return (
    <SKTBaseComponent label="Mitat" childrenInline={true}>
      <SKTDimensionPart prefix="p" unit="cm" id="iPDepth" data={data} />
      <Times />
      <SKTDimensionPart prefix="l" unit="cm" id="iPWidth" data={data} />
      <Times />
      <SKTDimensionPart prefix="k" unit="cm" id="iPHeight" data={data} />
    </SKTBaseComponent>
  );
};

export const SKTIndexedDimensions = ({ data, index }) => {
  return (
    <SKTBaseComponent label={`Kollin ${index} mitat`} childrenInline={true}>
      <SKTDimensionPart
        prefix="p"
        unit="cm"
        id={`iPDepth${index}`}
        data={data}
      />
      <Times />
      <SKTDimensionPart
        prefix="l"
        unit="cm"
        id={`iPWidth${index}`}
        data={data}
      />
      <Times />
      <SKTDimensionPart
        prefix="k"
        unit="cm"
        id={`iPHeight${index}`}
        data={data}
      />
    </SKTBaseComponent>
  );
};
